// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-prgress-bar {
    position: absolute;
    z-index: 1;
}

:host {
    display: block;
}

a {
    color: red;
    cursor: pointer;
    text-decoration: underline;
}

@keyframes router-load-indicator-animation {
    from {
        opacity: 0.0;
    }

    to {
        opacity: 1.0;
    }
}

.router-load-indicator {
    animation-delay: 100ms;
    animation-duration: 200ms;
    animation-fill-mode: both;
    animation-name: router-load-indicator-animation;
    background-color: #ffdc73;
    border-radius: 5px 5px 5px 5px;
    box-shadow: 0px 2px 2px fade(#000000, 20%);
    color: #000000;
    font-family: monospace;
    font-size: 16px;
    left: 50%;
    padding: 7px 15px 7px 15px;
    position: fixed;
    text-transform: lowercase;
    top: 10px;
    transform: translateX(-50%);
    z-index: 2;
}


.fixposition {
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 10px;
    z-index: 9999;
    border-radius: 4px;
    max-width: 33vw;
    min-width: 344px;
}

.init-image-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,+CAA+C;IAC/C,yBAAyB;IACzB,8BAA8B;IAC9B,0CAA0C;IAC1C,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,SAAS;IACT,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;IACzB,SAAS;IACT,2BAA2B;IAC3B,UAAU;AACd;;;AAGA;IACI,eAAe;IACf,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB;AACJ","sourcesContent":[".page-prgress-bar {\n    position: absolute;\n    z-index: 1;\n}\n\n:host {\n    display: block;\n}\n\na {\n    color: red;\n    cursor: pointer;\n    text-decoration: underline;\n}\n\n@keyframes router-load-indicator-animation {\n    from {\n        opacity: 0.0;\n    }\n\n    to {\n        opacity: 1.0;\n    }\n}\n\n.router-load-indicator {\n    animation-delay: 100ms;\n    animation-duration: 200ms;\n    animation-fill-mode: both;\n    animation-name: router-load-indicator-animation;\n    background-color: #ffdc73;\n    border-radius: 5px 5px 5px 5px;\n    box-shadow: 0px 2px 2px fade(#000000, 20%);\n    color: #000000;\n    font-family: monospace;\n    font-size: 16px;\n    left: 50%;\n    padding: 7px 15px 7px 15px;\n    position: fixed;\n    text-transform: lowercase;\n    top: 10px;\n    transform: translateX(-50%);\n    z-index: 2;\n}\n\n\n.fixposition {\n    position: fixed;\n    left: 0;\n    right: 0;\n    margin: auto;\n    bottom: 10px;\n    z-index: 9999;\n    border-radius: 4px;\n    max-width: 33vw;\n    min-width: 344px;\n}\n\n.init-image-loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 100vh\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
